/**
 * Created by zhaoyao on 19:45.
 * 充值详情界面
 */
import React from 'react';
import {Icon, Divider, Button, Select } from "antd";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast } from "antd-mobile";

const Option = Select.Option;
class AddressBookAdd extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'addressBookAdd',
            data:{

            },
            IMEI: this.props.match.params.IMEI,
            contacts: null,
            phone: null,
        };
    }


    componentDidMount(){

    }
     handleChange = (value) => {
      console.log(`selected ${value}`);
      this.setState({
          contacts: value,
      })
    }
    render(){

        return (<div>

                <div className="flex_row padding_10  bg_white">
                     <div className="flex_column">
                         <div className="span_14  text_bold">联系人名称</div>
                     </div>
                     <div className="flex_center_vertical_end item_flex">
                       <Select showSearch
                         style={{ width: 200 }}
                         placeholder="联系人名称"
                         optionFilterProp="children"
                         notFoundContent="无法找到"
                         searchPlaceholder="输入关键词"
                         onChange={this.handleChange}>
                         <Option value="爸爸">爸爸</Option>
                         <Option value="妈妈">妈妈</Option>
                         <Option value="爷爷">爷爷</Option>
                         <Option value="奶奶">奶奶</Option>
                         <Option value="外公">外公</Option>
                         <Option value="外婆">外婆</Option>
                         <Option value="哥哥">哥哥</Option>
                         <Option value="姐姐">姐姐</Option>
                         <Option value="班主任">班主任</Option>
                       </Select>

                     </div>
                 </div>
                <div className="notify-item-line"></div>


                <div className="flex_row padding_10  bg_white" onChange={this.handelValueCom}>
                     <div className="flex_column">
                         <div className="span_14  text_bold">手机号码或短号</div>
                     </div>
                     <input ref='phone' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.phone}/>
                </div>
                <div className="notify-item-line"></div>

            <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30,width: '80%'}}
                                                onClick={this.onNextClick}>保存</Button>

        </div>)
    }
    onNextClick = (value) => {

        if(this.state.contacts == null || this.state.contacts == ''){
            Toast.show('请输入关系',1)
            return
        }
        if(this.state.phone == null || this.state.phone == ''){
            Toast.show('请输入电话',2)
            return
        }
          fetchPost(API.ADD_ELECTRONIC_ADDRESS, {
                IMEI: this.state.IMEI,
                contacts: this.state.contacts,
                phone: this.state.phone,
            }).then(response => {
                if (response.success) {

                    this.backTask = setTimeout(() => {
                        this.props.history.goBack();
                    }, 1000)
                }

            }).catch(error => {
                Toast.hide();

                if (typeof error === 'string') {
                    Toast.fail(error, 2)
                } else {
                    Toast.fail('请求异常', 2)
                }
          })
    }
    handelValueCom = (event)=>{
        //获取用户名的值
        let phone = this.refs.phone.value;
        //获得内容的值
        this.setState({
            phone:phone,
        })
    }

}

export  default AddressBookAdd;